export const styles = {
    card:{
        background:"transparent",
        fontFamily:"Montserrat, sans-serif",
        boxShadow:"none",
        overflow:"hidden", 
        position:"relative", 
        margin:"5px auto", 
        width:"160px", 
        height:"230px", 
        borderRadius:"5px"
    },
    
    /* Content face — white frame (outline), inset coloured panel inside */
    cardContent:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"5px",
        top:"0",
        left:"0",
        background:"#FFF",
        transition:"0.5s",
        transformStyle:"preserve-3d",
        transform:"rotateY(0deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"8px",
        opacity:1,
        zIndex:1
    },

    cardContentFlip:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"5px",
        background:"#FFF",
        top:"0",
        left:"0",
        transition:"0.5s",
        transformStyle:"preserve-3d",
        transform:"rotateY(180deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"8px",
        opacity:0,
        zIndex:0
    },

    /* Shared card-design classes (match the canvas card design; sizing kept to this scale) */
    cardInnerPanel:{
        position:"relative",
        height:"100%",
        width:"100%",
        borderRadius:"6px",
        overflow:"hidden",
        display:"flex",
        flexDirection:"column",
    },

    cardHeaderRow:{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        padding:"8px 8px 2px 8px",
        flexShrink:0,
        position:"relative",
        zIndex:3,
    },

    cardTitle:{
        flex:1,
        minWidth:0,
        textAlign:"center",
        fontSize:"13px",
        fontWeight:"bold",
        margin:"0 4px",
        whiteSpace:"nowrap",
        overflow:"hidden",
        textOverflow:"ellipsis",
    },

    cardHeaderMenuBtn:{
        padding:"2px",
        width:"24px",
        height:"24px",
        flexShrink:0,
        '&:focus':{ outline:"none" },
    },

    cardFooter:{
        position:"absolute",
        bottom:0,
        left:0,
        right:0,
        padding:"4px 8px 8px 8px",
        fontSize:"11px",
        fontWeight:"normal",
        zIndex:3,
        whiteSpace:"nowrap",
        overflow:"hidden",
        textOverflow:"ellipsis",
    },

    cardCoverHero:{
        flex:1,
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
    },

    imgFill:{
        position:"absolute",
        top:0,
        left:0,
        right:0,
        bottom:0,
        overflow:"hidden",
        zIndex:1,
        "&:hover $imgDelete":{
            background:"rgba(0,0,0, 0.7)",
            color:"white"
        }
    },

    iconRight:{
        fontSize:"10px",
        float:"right",
        '&:focus':{
            outline:"none"
        }
    },

    sendRight:{
        float:"right",
        width:"30px", 
        height:"30px", 
        fontSize:"16px",
        marginTop:"10px", 
        color:"#4173D6", 
        opacity:1,
        '&:focus':{
            outline:"none"
        }
    },

    sendRightHide:{
        float:"right",
        width:"30px", 
        height:"30px", 
        fontSize:"16px",
        marginTop:"10px", 
        color:"#4173D6", 
        opacity:0,
        '&:focus':{
            outline:"none"
        }
    },

    contentWrapper:{
        position:"relative",
        margin:0,
        marginTop:"7px",
        minWidth:0,
        flex:1,
        overflow:"hidden",
    },

    content:{
        width:"100%",
        height:"100%",
        overflowY:"auto",
        padding:"2px 8px 26px 8px",
        fontFamily:"Inter",
        fontWeight:"500"
    },

    counterShow:{
        display:"inline-block",
        fontSize:"10px",
        margin:"0",
        marginTop:"0px",
        opacity:1,
        color:"#C4C4C4"
    },

    counterHide:{

        opacity:0
    },

    username:{
        fontSize:"10px",
        margin:"0", 
        fontWeight:"bold"
    },

    pin:{
        fontSize:"12px", 
        marginLeft:"2px", 
        marginTop:"2px"
    },
    /* Back Card Cover */
    cardCover:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"5px",
        transition:"0.5s",
        top:"0",
        left:"0",
        background:"#FFF",
        opacity:1,
        transformStyle:"preserve-3d",
        transform:"rotateY(180deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"8px",
        zIndex:0
    },

    cardCoverFlip:{
        position:"absolute",
        height:"calc(100%)",
        width:"100%",
        padding:"5px",
        top:"0",
        left:"0",
        transition:"0.5s",
        background:"#FFF",
        opacity: 1,
        transformStyle:"preserve-3d",
        transform:"rotateY(0deg)",
        border:"0.5px solid #c4c4c4",
        borderRadius:"8px",
        zIndex:1
    },

    cardCoverIconWrapper:{
        margin:"25px 0",
    },
    
    cardCoverCategory:{
        fontSize:"12px",
        textAlign:"center",
        fontWeight:"bold"
    },

    cardCoverInfo:{
        fontSize:"10px",
        textAlign:"center"
    },

    /* Menu */
    menuItem:{
        fontSize:"12px"
    },
    menuIcon:{
        fontSize:"16px",
        marginRight:"5px"
    },

    tag:{
        display:"inline-block", 
        cursor:"pointer", 
        background:"#D1D1D1", 
        width:"fit-content", 
        margin:"0", 
        outline:"none", 
        color:"#4F4F4F", 
        marginTop:"10px",
        fontSize:"10px",
        padding:"5px 10px", 
        marginRight:"10px", 
        borderRadius:"10px"
    },
    imgHolder:{
        position:"relative", 
        width:"100%", 
        height:"125px", 
        overflow:"hidden",
        "&:hover $imgDelete":{ 
            background:"rgba(0,0,0, 0.7)",
            color:"white"
        }
    },

    imgDelete:{
        position:"absolute", 
        right:"5px", 
        top:"5px", 
        width:"10px", 
        height:"10px", 
        background:"transparent", 
        color:"transparent", 
        zIndex:"2", 
        transition:"0.5s", 
    },

    dropZone:{
        width:"100%", 
        height:"125px", 
        border:"1px dashed #C4C4C4", 
        background:"#F2F2F2", 
        color:"#C4C4C4", 
        lineHeight: "110px", 
        fontSize:"8px", 
        fontFamily:"Montserrat", 
        textAlign:"center"
    }
}

export default styles;